import React, { useEffect } from "react";
import LeaderboardPage from "../../components/leaderboard";
import { MixpanelEvent, trackEvent } from "../../analytics/mixpanel";

const Leaderboard = () => {
  const isPageViewTracked = React.useRef(false);

  useEffect(() => {
    if (isPageViewTracked.current) return;
    trackEvent(MixpanelEvent.PAGE_VIEW, { page_name: "leaderboard" });
    isPageViewTracked.current = true;
  }, []);
  return (
    <div className="min-h-screen w-screen bg-gray-100 pt-6">
      <LeaderboardPage />
    </div>
  );
};

export default Leaderboard;
